import type { ListLocationsCommandInput } from '@amzn/gbsa-helios-typescript-client';

/**
 * React Query key factory for the v2 locations listing.
 *
 * Keys are intentionally namespaced under `v2.locations` so they don't
 * collide with any legacy `'locations'` keys that may exist in the same
 * QueryClient cache during the migration window.
 */
export const v2LocationKeys = {
  all: ['v2', 'locations'] as const,
  lists: () => [...v2LocationKeys.all, 'list'] as const,
  list: (filters: Partial<ListLocationsCommandInput>) =>
    [...v2LocationKeys.lists(), filters] as const,
};
